// COMMON INPUT STYLES
import styled from '@emotion/styled';
import setMargin from '../../helpers/set-margin';

const commonStyle = `
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 150%;
`;

export const commonBorderStyle = ({ theme, error, disabled }) => `
  border: ${error ? theme.borders.error : theme.borders.inputs};
  border-radius: ${theme.borders.radius};
`;

export const placeholderStyle = ({ theme }) => `
  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    ${commonStyle};
    font-family: 'Heebo', sans-serif;
    color: ${theme.colors.neutralMain};
  }
  ::-moz-placeholder { /* Firefox 19+ */
    ${commonStyle};
    font-family: 'Heebo', sans-serif;
    color: ${theme.colors.neutralMain};
  }
  :-ms-input-placeholder { /* IE 10+ */
    ${commonStyle};
    font-family: 'Heebo', sans-serif;
    color: ${theme.colors.neutralMain};
  }
  :-moz-placeholder { /* Firefox 18- */
    ${commonStyle};
    font-family: 'Heebo', sans-serif;
    color: ${theme.colors.neutralMain};
  }
`;

export const Field = styled.div`
  ${setMargin};
  width: ${({ w }) => w || '100%'};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
`;

export const Label = styled.label`
  ${setMargin};
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const OptionalTag = styled.span`
  ${setMargin};
  display: inline-block;
  font-weight: 400 !important;
  color: ${({ theme }) => theme.colors.neutralMain};
`;
